import { z } from "zod";
import { MetaSchema } from "./shared";

export const UsersProfitsSchema = z.object({
  dailyProfit: z.number(),
  profitCanWithdraw: z.string(),
  totalReturnOfPrincipal: z.number(),
});

const UsersProfitsResponse = z.object({
  data: UsersProfitsSchema,
  meta: MetaSchema.default,
});

export type UsersProfitsResponseType = z.infer<typeof UsersProfitsSchema>;

export default UsersProfitsResponse;
